import React from 'react';
import siteContent from '../../data/siteContent';
import useLockBodyScroll from '../../hooks/useLockBodyScroll';

function MobileDrawer({ menuOpen, setMenuOpen }) {
  useLockBodyScroll(menuOpen);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className={`nav-drawer ${menuOpen ? 'open' : ''}`}>
      <ul>
        {siteContent.nav.map((item) => (
          <li key={item.href}>
            <a href={item.href} className="drawer-link" onClick={closeMenu}>
              {item.label}
            </a>
          </li>
        ))}
        <li>
          <a
            href={`https://wa.me/${siteContent.whatsapp.number}`}
            target="_blank"
            rel="noreferrer"
            className="drawer-link drawer-wapp"
            onClick={closeMenu}
          >
            WhatsApp
          </a>
        </li>
      </ul>
    </div>
  );
}

export default MobileDrawer;